// GLOBAL VARIANTS ------------------------------------------------------------------------------------

const variantOptionIdInput = document.querySelector('input[name="id"]');
const buttonSubmit = document.querySelector('button[type="submit"]');
const priceButtonSubmit = document.querySelector(
  'button[type="submit"] .price-item'
);

const productFormTotal = document.querySelector(
  ".product-form__buttons .product-form__total"
);
const productButtonSeparator = document.querySelector(
  ".product-form__buttons .product_button_separator"
);

function checkVariantSelected() {
  if (variantOptionIdInput.value == "") {
    buttonSubmit.setAttribute("disabled", "");
    productFormTotal.style.display = "none";
    productButtonSeparator.style.display = "none";
  } else {
    const onlyDigits = /^\d+$/.test(variantOptionIdInput.value);
    if (onlyDigits) {
      buttonSubmit.removeAttribute("disabled");
      productFormTotal.style.display = "block";
      productButtonSeparator.style.display = "block";
    } else {
      console.log(
        "Erreur : l'ID contient d'autres caractères que des chiffres : "
      );
      console.log(variantOptionIdInput.value);
    }
  }
}
checkVariantSelected();

// COLOR VARIANTS ------------------------------------------------------------------------------------

const colorVariantOptions = document.querySelectorAll(
  ".product_variants_color .options .item"
);

colorVariantOptions.forEach((item) => {
  item.addEventListener("click", () => {
    for (i = 0; i < colorVariantOptions.length; i++) {
      colorVariantOptions[i].classList.remove("selected");
    }
    item.classList.add("selected");
    variantOptionIdInput.value = item.getAttribute("value");
    checkVariantSelected();
  });
});

// AMOUNT VARIANTS ------------------------------------------------------------------------------------

const mainOptionAmountVariant = document.querySelector(
  ".product_variants_amount .options"
);
const amountVariantOptions = document.querySelectorAll(
  ".product_variants_amount .options .item"
);
const svgAmountVariantOptions = document.querySelector(
  ".product_variants_amount svg"
);

amountVariantOptions.forEach((item) => {
  item.addEventListener("click", () => {
    if (mainOptionAmountVariant.classList.contains("open")) {
      if (item.getAttribute("value") != null) {
        const initialAmount = item.getAttribute("price");
        const amount = (parseFloat(initialAmount) / 100) * 1;
        const formattedAmount = amount.toLocaleString("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const textPriceproduct = (document.querySelector(
          "#text-price"
        ).innerHTML = formattedAmount);
        priceButtonSubmit.innerHTML = formattedAmount;
        variantOptionIdInput.value = item.getAttribute("value");
        amountVariantOptions[0].innerHTML = item.textContent;
      }
      mainOptionAmountVariant.classList.remove("open");
      svgAmountVariantOptions.style.transform = "rotate(0deg)";
    } else {
      mainOptionAmountVariant.classList.add("open");
      svgAmountVariantOptions.style.transform = "rotate(-180deg)";
    }
    checkVariantSelected();
  });
});
